import { connect } from "react-redux"
import { Navigate, Route, Routes, useLocation } from "react-router-dom"
import styled from "styled-components"

import "./stylesheets/App.scss"
import EditUserModal from "./components/EditUserModal"
import Layout from "./components/Layout"
import Login from "./components/Login"
import LogoBar from "./components/LogoBar"
import Toasts from "./components/Toasts"
import User from "./components/User"
import UserSearch from "./components/UserSearch"

import { handleAuthentication, login } from "flows/authentication/actions"

const StyledLayout = styled(Layout)`
  padding-bottom: 0;
`

const Callback = ({ auth, handleAuthentication }) => {
    const location = useLocation()

    if (
        auth.accessToken === undefined
        && auth.error === undefined
        && /access_token|id_token|error/.test(location.hash)
    ) {
        handleAuthentication()
    }

    if (auth.error) {
        return <p>An error occurred when setting up the session: {auth.error.error}</p>
    } else if (auth.accessToken) {
        return <Navigate to="/" replace />
    } else {
        return <p>Setting up session...</p>
    }
}

const App = ({ auth, login, handleAuthentication, toasts, config }) => {
    if (Object.entries(config).length === 0) {
        return <p>Loading configuration...</p>
    } else {
        return (
            <Layout>
                <StyledLayout main>
                    <LogoBar />
                    <Layout body>
                        <Routes>
                            <Route
                                path="/"
                                element={auth.accessToken ? <UserSearch /> : <Login login={login} config={config} />}
                            />
                            <Route path="/user" element={<User />} />
                            <Route
                                path="/callback"
                                element={<Callback auth={auth} handleAuthentication={handleAuthentication} />}
                            />
                        </Routes>
                    </Layout>
                </StyledLayout>
                <EditUserModal />
                <Toasts toasts={toasts} />
            </Layout>
        )
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
        toasts: state.messages.list,
        config: state.config,
    }
}

const mapDispatchToProps = dispatch => ({
    login: config => dispatch(login(config)),
    handleAuthentication: () => dispatch(handleAuthentication()),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App)
